module.exports = __webpack_public_path__ + "static/media/TINY.7e461787.JPG";